module.exports = __webpack_public_path__ + "static/media/notice-6.498de317.jpg";